import React from 'react';
import PropTypes from 'prop-types';
import { CHILDREN_PROPTYPES } from 'base/constants/propTypes';

class ScrollIntoView extends React.Component {
  static propTypes = {
    shouldScrollIntoView: PropTypes.bool,
    settings: PropTypes.shape({}),
    children: CHILDREN_PROPTYPES
  };

  static defaultProps = {
    settings: { behavior: 'smooth', block: 'center' }
  };

  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }

  componentDidUpdate() {
    if (this.props.shouldScrollIntoView) {
      this.ref.current.scrollIntoView(this.props.settings);
    }
  }

  render() {
    return (
      <React.Fragment>
        {this.props.children} <span ref={this.ref} />
      </React.Fragment>
    );
  }
}

export default ScrollIntoView;
